import {Injectable} from '@angular/core';
import {ModalService} from '../modal-service.service';
import {FirmLogoModalComponent} from './firm-logo-modal.component';

@Injectable({
    providedIn: 'root'
})
export class FirmLogoModalService extends ModalService {
    showModal() {
        this.createModalComponent(FirmLogoModalComponent);
        const firmLogoModalComponentInstance = this.modalComponentRef.instance as FirmLogoModalComponent;
        firmLogoModalComponentInstance.title = 'Upload Firm Logo';
        this.showModalComponent();
        return firmLogoModalComponentInstance.modalClosed;
    }
}
